module.exports = __webpack_public_path__ + "static/media/img_53.ffe1c435.png";